export default __webpack_public_path__ + "static/BeTRITON-white-c19b26a90192c5599dd8ac9e38d271a6.png";